import { IAjaxConfig } from '../libraries';
export class EnumApiCultivate {
  /**
   * @dec 获取云学堂重定向地址
   */
  readonly cultivate_get_yxt_url: IAjaxConfig = {
    url: '/api/gateway/bp-integrate-cultivate/auth/url/query',
    method: 'post',
    loading: true,
  };
}
